import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import { submitData } from '../Services/submitData';

export default function useProductMasterMutation() {
	const { accessToken } = useAuth();
	const queryClient = useQueryClient();
	const mutation = useMutation({
		mutationFn: (transformedData) => submitData(accessToken, transformedData),
		onSuccess: async () => {
			await queryClient.invalidateQueries({ queryKey: ['productMasterData'] });
			await queryClient.invalidateQueries({ queryKey: ['forecast'] });
			await queryClient.invalidateQueries({ queryKey: ['salesTracking'] });
		},
	});
	return mutation;
}
